import { createRef } from 'react'
import { TextField } from '@machobear/design-system'
import { useField, useFormikContext } from 'formik'
import noop from 'lodash/noop'
import useFocusOnError from '@/hooks/use-focus-on-error'

const format = (value: string) => value.replace(/(\d)(?=(\d{3})+(\.(\d){0,2})*$)/g, '$1,')
const parse = (value: string) => value.match(/[\d.]+/g)?.join('')

export const CurrencyField = ({
  name,
  label,
  onChange = noop,
  onBlur = noop,
  maxLength,
  required = false,
  disabled = false,
  ...props
}: {
  name: string
  label: string
  onChange?: (e: React.ChangeEvent<any>) => void
  onBlur?: () => void
  maxLength?: number
  required?: boolean
  disabled?: boolean
}) => {
  const fieldRef = createRef<HTMLInputElement>()
  const { setFieldValue } = useFormikContext()
  const [field, meta] = useField(name)
  const { value, onBlur: formikOnBlur } = field
  useFocusOnError({ fieldRef, name })

  const onChangeField = (e: any) => {
    setFieldValue(name, parse(e.target.value))
    if (onChange) onChange(e)
  }

  const onBlurField = (e: any) => {
    formikOnBlur(e)
    onBlur()
  }

  return (
    <TextField
      ref={fieldRef}
      id={name}
      name={name}
      value={value ? '$' + format(value) : ''}
      onChange={onChangeField}
      onBlur={onBlurField}
      label={label}
      required={required}
      maxLength={maxLength}
      disabled={disabled}
      tone={meta.error ? 'critical' : 'neutral'}
      {...props}
    />
  )
}
